import { createContext } from 'react';

export const HeadContext: React.Context<any> = createContext(null);
